'use strict';

var _classCallCheck = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var CID = require('cids');

var assert = require('assert');

var withIs = require('class-is');

var visibility = require('../visibility'); // Link represents an IPFS Merkle DAG Link between Nodes.


var DAGLink = /*#__PURE__*/function () {
  function DAGLink(name, size, cid) {
    _classCallCheck(this, DAGLink);

    assert(cid, 'A link requires a cid to point to'); // assert(size, 'A link requires a size')
    //  note - links should include size, but this assert is disabled
    //  for now to maintain consistency with go-ipfs pinset

    this._name = name || '';
    this._nameBuf = null;
    this._size = size;
    this._cid = new CID(cid); // Make sure we have a nice public API that can be used by an IPLD resolver

    visibility.hidePrivateFields(this);
    visibility.addEnumerableGetters(this, ['Hash', 'Name', 'Tsize']);
  }

  _createClass(DAGLink, [{
    key: "toString",
    value: function toString() {
      return "DAGLink <".concat(this._cid.toBaseEncodedString(), " - name: \"").concat(this.Name, "\", size: ").concat(this.Tsize, ">");
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      if (!this._json) {
        this._json = Object.freeze({
          name: this.Name,
          size: this.Tsize,
          cid: this.Hash.toBaseEncodedString()
        });
      }

      return Object.assign({}, this._json);
    }
  }, {
    key: "Name",
    get: function get() {
      return this._name;
    } // Memoize the Buffer representation of name
    // We need this to sort the links, otherwise
    // we will reallocate new buffers every time
    ,
    set: function set(name) {
      throw new Error("Can't set property: 'name' is immutable");
    }
  }, {
    key: "nameAsBuffer",
    get: function get() {
      if (this._nameBuf !== null) {
        return this._nameBuf;
      }

      this._nameBuf = Buffer.from(this._name);
      return this._nameBuf;
    }
  }, {
    key: "Tsize",
    get: function get() {
      return this._size;
    },
    set: function set(size) {
      throw new Error("Can't set property: 'size' is immutable");
    }
  }, {
    key: "Hash",
    get: function get() {
      return this._cid;
    },
    set: function set(cid) {
      throw new Error("Can't set property: 'cid' is immutable");
    }
  }]);

  return DAGLink;
}();

exports = module.exports = withIs(DAGLink, {
  className: 'DAGLink',
  symbolName: '@ipld/js-ipld-dag-pb/daglink'
});
exports.util = require('./util');